import React from 'react';
import { Route } from 'react-router-dom';

import { PUBLIC_EDITORIAL_APP_PATHS } from '../constants/public-editorial-paths.constants';
import EnterpriseOfferView from '../views/public/EnterpriseOffer.view';
import FruitBasketView from '../views/public/FruitBasket.view';
import EcoPointsView from '../views/public/EcoPoints.view';
import GroupOrderView from '../views/public/GroupOrder.view';
import OurProductsView from '../views/public/OurProducts.view';
import OurValuesView from '../views/public/OurValues.view';
import ZeroWasteView from '../views/public/ZeroWaste.view';

export default function PublicEditorialRoutes() {
  return (
    <React.Fragment>
      <Route exact path={PUBLIC_EDITORIAL_APP_PATHS.OUR_VALUES} component={OurValuesView} />
      <Route exact path={PUBLIC_EDITORIAL_APP_PATHS.OUR_PRODUCTS} component={OurProductsView} />
      <Route exact path={PUBLIC_EDITORIAL_APP_PATHS.ZERO_WASTE} component={ZeroWasteView} />
      <Route exact path={PUBLIC_EDITORIAL_APP_PATHS.ENTERPRISE_OFFER} component={EnterpriseOfferView} />
      <Route exact path={PUBLIC_EDITORIAL_APP_PATHS.FRUIT_BASKET} component={FruitBasketView} />
      <Route exact path={PUBLIC_EDITORIAL_APP_PATHS.GROUP_ORDER} component={GroupOrderView} />
      <Route exact path={PUBLIC_EDITORIAL_APP_PATHS.ECO_POINTS} component={EcoPointsView} />
    </React.Fragment>
  );
}
